// extracted by mini-css-extract-plugin
module.exports = {"edited":"Parameter_edited__m832b"};